import { render, staticRenderFns } from "./StudentQuizQuestion.vue?vue&type=template&id=752f5eee"
import script from "./StudentQuizQuestion.vue?vue&type=script&lang=js"
export * from "./StudentQuizQuestion.vue?vue&type=script&lang=js"
import style0 from "./StudentQuizQuestion.vue?vue&type=style&index=0&id=752f5eee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports